module.exports = __webpack_public_path__ + "img/ic_wangluo(2).df56ca46.png";